
export const closeOrderPopUp = (status, msg1, msg2,error=false) => {
    return {
        type: 'Close_Order_PopUp',
        payload: {
            status,
            msg1,
            msg2,
            error
        }
    }
}

export const setCustomLocation = (link) => {
    return{
        type:"Set_Custom_Location",
        payload : link
    }
}

export const setMapSnapshot = (uri) => {
    return{
        type:"Set_map_snapshot",
        payload:uri
    }
}

export const setHcommerceWidget = (widget) => {
    return{
        type:"Set_hcommerce_widget",
        payload : widget
    }
}

export const setShowPlaceOrder = (bool) => {
    return{
        type:"Set_show_place_order",
        payload : bool
    }
}

export const setSelectedGuestName = name => {
    return{
        type: "Set_Selected_Guest_Name",
        payload: name
    }
}

export const setMapOpened = bool => {
    return {
        type: "Set_Map_Opened",
        payload: bool
    }
}
